<template>
  <li :class="[$style.item, { [$style.thin]: isThin }]">
    <a :href="to" :class="$style.inner">
      <img :class="$style.icon" :src="icon" width="40" alt="icon" />
      <div :class="$style.label">
        <span class="tk-linotype-didot-headline" :class="$style.main">{{
          label
        }}</span>
        <span class="g-subtitle4" :class="$style.sub">{{ subtitle }}</span>
      </div>
      <template v-if="hasArrow">
        <span :class="$style.divider" />
        <i
          class="icon-chevronup"
          :class="[$style.arrow, $style.isSp, { [$style.arrowOpen]: isOpen }]"
          @click.prevent="onArrowClick"
        />
      </template>
      <i class="icon-chevronright" :class="[$style.arrow, $style.isPc]" />
    </a>
    <template v-if="hasChildLinks">
      <Component :is="isPc ? 'div' : 'VcHeightTransition'">
        <div v-if="isOpen || isPc">
          <ul :class="$style.childLinks">
            <li
              v-for="child in childLinks"
              :key="child.name"
              :class="$style.childLink"
              :style="getChildLinkStyle(child.name)"
            >
              <a
                class="g-subtitle2"
                :class="$style.childLinkItem"
                :href="child.to"
                >{{ child.name }}</a
              >
            </li>
          </ul>
        </div>
      </Component>
    </template>
  </li>
</template>

<script>
  import VcHeightTransition from "./VcHeightTransition.vue";

  export default {
    components: {
      VcHeightTransition,
    },
    props: {
      icon: {
        type: String,
        required: true,
        default: "",
      },
      label: {
        type: String,
        required: true,
        default: "",
      },
      subtitle: {
        type: String,
        required: true,
        default: "",
      },
      hasArrow: {
        type: Boolean,
        required: false,
        default: false,
      },
      isThin: {
        type: Boolean,
        required: false,
        default: false,
      },
      to: {
        type: String,
        default: "/",
      },
      childLinks: {
        type: Array,
        required: false,
        default() {
          return [];
        },
      },
    },
    data() {
      return {
        isOpen: false,
        isPc: false,
      };
    },
    computed: {
      hasChildLinks() {
        return this.childLinks.length !== 0;
      },
    },
    mounted() {
      window.addEventListener("resize", this.onWindowResize);
      this.onWindowResize();
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.onWindowResize);
    },
    methods: {
      getChildLinkStyle(linkName) {
        const name = linkName.replace(/[\s.]/g, "");
        return name.length > 8 ? { flexBasis: "20em" } : {};
      },
      onWindowResize() {
        if (window.innerWidth < 769) {
          this.isPc = false;
        } else {
          this.isPc = true;
        }
      },
      onArrowClick() {
        this.isOpen = !this.isOpen;
      },
    },
  };
</script>

<style module>
  .item {
    padding: 0;
  }
  .item:first-child {
    border-top: solid 1px #e6e6e6;
  }

  .inner {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 72px;
    border-bottom: solid 1px #e6e6e6;
  }
  .icon {
    flex: 0 0 40px;
    margin-left: 16px;
  }
  .label {
    flex: 1 0 0;
    display: flex;
    flex-direction: column;
    margin: 0 0 0 12px;
  }
  .divider {
    display: inline-block;
    margin: 0 12px 0 0;
    width: 1px;
    height: 56px;
    background-color: #e6e6eb;
  }
  .arrow {
    flex: 0 0 40px;
    display: inline-block;
    margin-right: 8px;
    width: 40px;
    height: 40px;
    color: rgba(17, 17, 17, 0.33);
    font-size: 24px;
    text-align: center;
    line-height: 40px;
    transform: rotate(180deg);
    transition: all 0.15s;
    color: #e4007f;
  }
  .arrowOpen {
    transform: rotate(0deg);
  }

  .main {
    color: rgba(17, 17, 17, 0.8);
    font-size: 26px;
    line-height: 1;
  }
  .sub {
    color: #e4007f;
  }

  .childLinks {
    display: flex;
    flex-wrap: wrap;
    padding: 20px 0 20px 68px;
    background: #f5f3f1;
    overflow: hidden;
  }
  .childLink {
    flex: 0 1 8em;
    padding: 13px 6px 13px 0;
    line-height: 18px;
  }
  .childLinkItem {
    position: relative;
    padding-left: 8px;
    color: rgba(17, 17, 17, 0.8);
  }
  .childLinkItem::after {
    content: "";
    position: absolute;
    top: 3px;
    left: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px 0 5px 5px;
    border-color: transparent transparent transparent #e4007d;
  }
  .isPc {
    display: none;
  }
  @media screen and (min-width: 769px) {
    .inner {
      background-color: #fff;
      border-bottom: none;
      justify-content: flex-start;
      position: relative;
    }
    .icon {
      margin-left: 8px;
    }
    .label {
      max-width: 267px;
      margin-right: 0;
    }
    .item.thin .label {
      max-width: 267px;
      margin: 0 0 0 8px;
    }
    .item {
      flex-basis: 25%;
    }
    .item.thin {
      flex-basis: 25%;
      background: #faf9f8;
    }
    .item:first-child {
      border-top: none;
      position: relative;
    }
    .item.thin .inner {
      box-shadow: none;
    }
    .item.thin .main {
      font-size: 22px;
    }
    .divider {
      display: none;
    }
    .childLinks {
      background: none;
      z-index: 1;
      padding: 9px 0 41px 60px;
      max-width: 375px;
    }
    .childLink {
      padding: 12px 6px 12px 0;
    }
    .sub {
      margin-top: 5px;
    }
    .arrow {
      flex: 0 0 40px;
      display: inline-block;
      width: 40px;
      height: 40px;
      font-size: 24px;
      line-height: 40px;
      transform: rotate(0);
      position: absolute;
      top: 0;
      bottom: 0;
      right: 8px;
      margin: auto;
    }
    .isSp {
      display: none;
    }
  }
  @media screen and (min-width: 769px) and (max-width: 1200px) {
    .item.thin {
      flex-basis: 50%;
    }
    .main {
      font-size: 24px;
    }
  }
</style>
